import Sharer from 'sharer.js';

import Nav from './components/nav';
import Sliders from './components/swiper';
import slab_Masonry from './components/masonry';
import Selects from './components/selects';
import Players from './components/players';
import Forms from './components/forms';
import Modal from './components/modal';
import SwiperHero from './swipers/swiperHero';
import Tabs from './components/tabs';
import CtaTabs from './components/cta-tabs';
import BackToTop from './components/backtotop';
import './components/script.js';

import { setupFilters, applyFilters, resetFilters } from './components/filters-mediatheques';
import { setupFiltersAnnonces, applyFiltersAnnonces, resetFiltersAnnonces } from './components/filters-annonces';

let swiperHeroInstance = null;

const initScripts = () => {
    new Nav();
    new Sliders();
    new slab_Masonry();
    new Selects();
    new Players();
    new Forms();
    new Modal();
    new Tabs();
    new CtaTabs();
    new BackToTop();
    if (!swiperHeroInstance) {
        swiperHeroInstance = new SwiperHero();
    }
};

document.addEventListener("DOMContentLoaded", function () {
    initScripts();
    setupFilters();
    setupFiltersAnnonces();
});
